import { SxProps, Theme } from '@mui/material';

export const userportalContainerStyles = {
	margin: '3rem auto',
};

export const withSidebarContainerStyles = {
	backgroundColor: 'background.neutral',
	minHeight: '100vh',
	padding: '1rem 0 0',
	flex: { md: '1 1 calc(100% - 300px)' },
	maxWidth: { md: 'calc(100% - 300px)' },
};

export const petCardStyles = {
	marginTop: '1rem',
	padding: '1.25rem',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'space-between',
	width: { xs: '100%', md: '20rem' },
	borderRadius: '0.5rem',
};

export const petCardsContainerStyles = {
	display: 'flex',
	flexDirection: { xs: 'column', md: 'row' },
	flexWrap: 'wrap',
	gap: '1.25rem',
};

export const paperStyles = {
	padding: { sx: '0', md: '2.5rem' },
	borderRadius: '0.5rem',
	marginBottom: '2.5rem',
};

export const AccountPaperStyles = {
	padding: { xs: '1rem' },
	borderRadius: '0.5rem',
	marginBottom: '2.5rem',
};

export const dialogStyles: SxProps<Theme> = {
	'.MuiDialog-container': {
		alignItems: { xs: 'flex-end', md: 'center' },
	},
	'.MuiPaper-root': {
		maxWidth: '43.75rem',
		width: '100%',
		margin: '0',
		height: { xs: '100%', md: 'auto' },
	},
};

export const dialogHeaderStyles: SxProps<Theme> = {
	display: 'flex',
	justifyContent: 'space-between',
	backgroundColor: 'backgrounds.neutral',
};

export const dialogHeaderTitleStyles = {
	color: 'primary.main',
	fontSize: '2rem',
	fontWeight: '900',
	lineHeight: '2.5rem',
	letterSpacing: 0,
};

export const submitButtonStyles = {
	width: '100%',
};
